import React from "react"

// Make tables horizontal scrollable
const style = {
	overflow: "auto",
	display: "inline-block",
	width: "100%",
}

const TableWrapper = ({ children }: Props) => {
	return <div style={style}>{children}</div>
}

interface Props {
	children: any
}

export default TableWrapper
